// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ComCommande_wrapper__3JJ6N","loading":"ComCommande_loading__36gPh","picto":"ComCommande_picto__3Nd6x","input":"ComCommande_input__3_ohd"};